import {StandardCard} from "@laser-project/kyui";
import React from "react";
import {IPopulatedCutter} from "../../../types/FrontendTypes.ts";
import ImageRest from "../../../rest/ImageRest.ts";
import {getCutterStatusChips} from "../../StatusChips/CutterStatusChips.tsx";
import {Launch} from "@mui/icons-material";

export function ModalCutterCard({cutter, imageRest}: { cutter: IPopulatedCutter, imageRest: ImageRest }) {
    return <StandardCard
        key={cutter._id}
        image={imageRest.getUrlById(cutter.imageId)}
        imageAlt={`Rendered Model of ${cutter.name}`}
        title={cutter.name}
        chips={getCutterStatusChips(cutter)}
        menuActions={[
            {
                label: "Go to cutter page",
                onClick: () => window.open(`/cutter/${cutter._id}`, '_blank'),
                icon: <Launch/>,
            },
        ]}
        type="model"
        condensed={true}
    />
}